import React from 'react';
import BaseReport from './BaseReport';
import { Box, Typography, Breadcrumbs, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const DebtRepaymentBySplit: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb" sx={{ mb: 3 }}>
        <MuiLink component={RouterLink} underline="hover" color="inherit" to="/dashboard">
          Home
        </MuiLink>
        <MuiLink component={RouterLink} underline="hover" color="inherit" to="/reports">
          Reports
        </MuiLink>
        <Typography color="text.primary">Debt Repayment by Interest/Principal Split</Typography>
      </Breadcrumbs>
      <BaseReport title="Debt Repayment Schedule by Interest/Principal Split">
        {/* Add specific report content here */}
        <div>Report content will be displayed here</div>
      </BaseReport>
    </Box>
  );
};

export default DebtRepaymentBySplit; 